/**
 * Libellés — espace médecin / dentiste (harmonisé réception · infirmerie).
 */

export const DOCTOR_COPY = {
  TAGLINE_INSTITUTIONAL: 'Sécurité et santé : main dans la main vers le succès',

  LAYOUT: {
    NAVBAR_BRAND_PHYSICIAN: 'Médecine FUNTOA SMIE',
    NAVBAR_BRAND_HEAD_DOCTOR: 'Médecin chef FUNTOA SMIE',
    NAVBAR_BRAND_DENTIST: 'Soins dentaires FUNTOA SMIE',
    TOPBAR_SECTION_PHYSICIAN: 'Médecine',
    TOPBAR_SECTION_DENTIST: 'Soins dentaires',
    SIDE_MENU_SECTION: 'Interface médecin',
    SIDE_MENU_SECTION_PHYSICIAN: 'Espace médecin',
    SIDE_MENU_SECTION_DENTIST: 'Espace dentaire',
    TOPBAR_TAGLINE_PHYSICIAN:
      'Consultations · ordonnances · dossier patient — activité filtrée sur le site sélectionné',
    TOPBAR_TAGLINE_DENTIST:
      'Soins dentaires · consultations DENTAL · dossier adhérent sur le site courant',
    SIDE_QUICK_ACCESS: 'Acces rapide',
    SIDE_SUBMENU_ADMIN: 'Coordination & suivi',
    SIDE_NEW_CONSULT: '+ Nouvelle consultation',
    SIDEBAR_NAV_ARIA: 'Navigation principale',
    SIDEBAR_TOGGLE_COLLAPSED: 'Déplier le menu médecin',
    SIDEBAR_TOGGLE_EXPANDED: 'Replier le menu médecin',
    SIDEBAR_TOGGLE_COLLAPSED_SHORT: 'Déplier',
    SIDEBAR_TOGGLE_EXPANDED_SHORT: 'Replier',
    NO_SITE_ASSIGNED: 'Aucun site affecté au profil',
    SITE_SELECT_ARIA: 'Site de travail',
    SITE_CHIP_LABEL: 'Site',
    CHANGE_SITE_CHIP_TITLE: 'Changer le site de travail',
    CHANGE_SITE_MENU: 'Changer de site',
    ACCOUNT_FALLBACK: 'Compte',
    ACCOUNT_MENU_ARIA: 'Menu du compte médecin',
    SITE_GATE_BADGE: 'Ouverture de session clinique',
    SITE_GATE_TITLE: 'Choisir votre site de travail',
    SITE_GATE_DESC:
      'Sélectionnez le site clinique qui sera utilisé pour cette session. Les consultations, dossiers et prescriptions se chargeront ensuite sur ce site.',
    SITES_LOADING: 'Chargement des sites…',
    SITE_CARD_META_FALLBACK: 'Site clinique',
    SITE_CARD_CTA: 'Commencer',
    SITE_ACTIVE_TOAST: 'Site clinique actif : {name}'
  },

  PHYSICIAN_DASHBOARD: {
    BADGE_PHYSICIAN: 'Médecine',
    BADGE_DENTIST: 'Soins dentaires',
    PAGE_TITLE_PHYSICIAN: 'Tableau de bord',
    PAGE_TITLE_DENTIST: 'Tableau de bord',
    PAGE_SUBTITLE_PHYSICIAN:
      'Pilotage clinique du site sélectionné : consultations, dossier adhérent et modules métiers.',
    PAGE_SUBTITLE_DENTIST:
      'Pilotage clinicodentaire du site sélectionné. Les indicateurs concernent la filière DENTAL.',
    REFRESH: 'Actualiser',
    PRIMARY_TITLE: 'Actions prioritaires',
    PRIMARY_DESC: 'Démarrer une consultation ou ouvrir le dossier d’un adhérent.',
    QUICK_NEW_CONSULT: 'Nouvelle consultation',
    QUICK_NEW_CONSULT_HINT: 'Ouverture rapide sur le site actif',
    QUICK_FULL_CARE: 'Prise en charge complète',
    QUICK_FULL_CARE_HINT: 'Formulaire structuré de consultation',
    QUICK_DOSSIER: 'Dossier adhérent',
    QUICK_DOSSIER_HINT: 'Historique consolidé SMIE',
    STATS_TITLE: 'Indicateurs du site',
    STATS_SUBTITLE: 'Cliquez une carte pour ouvrir la file ou les ordonnances du site actif.',
    HUB_CLINICAL_TITLE: 'Modules cliniques',
    HUB_CLINICAL_SUBTITLE: 'Dossier, consultations, diagnostic, ordonnances et examens.',
    BADGE_READY: 'Actif',
    BADGE_SOON: 'À venir',
    STAT_CONSULT_TOTAL: 'Consultations',
    STAT_CONSULT_PENDING: 'En attente',
    STAT_CONSULT_DONE: 'Terminées',
    STAT_RX_ACTIVE: 'Ordonnances actives',
    STAT_HINT_CONSULT: 'Ouvrir les consultations',
    STAT_HINT_PENDING: 'Voir les consultations en attente',
    STAT_HINT_DONE: 'Voir les consultations terminées',
    STAT_HINT_RX: 'Ouvrir les ordonnances'
  },

  NAV: {
    dashboard: {
      label: 'Tableau de bord',
      hint: 'Vue synthèse et hub des modules'
    },
    dossier: {
      label: 'Dossier complet',
      hint: 'Historique, constantes et visites en un clic'
    },
    consultations: {
      label: 'Consultations',
      hint: 'File du site · filière assignée'
    },
    diagnostic: {
      label: 'Diagnostic',
      hint: 'Codifié ou texte libre selon protocoles'
    },
    prescriptions: {
      label: 'Ordonnances',
      hint: 'Ordonnances numériques reliées pharmacie'
    },
    pharmacieLocale: {
      label: 'Pharmacie locale',
      hint: 'Stock et délivrances du site'
    },
    examens: {
      label: 'Examens',
      hint: 'Analyses et examens complémentaires'
    },
    certificats: {
      label: 'Certificats',
      hint: 'Aptitude / inaptitude · supervision'
    },
    maladies: {
      label: 'Maladies',
      hint: 'Référentiel des maladies (code + nom)'
    },
    analyses: {
      label: 'Analyses médicales',
      hint: 'Catalogue institutionnel des analyses de laboratoire'
    },
    radiographies: {
      label: 'Radiographies',
      hint: 'Catalogue institutionnel des actes radiologiques'
    },
    joursRepos: {
      label: 'Jours de repos',
      hint: 'Attribution avec validation intégrée'
    },
    lettresReference: {
      label: 'Lettres de référence',
      hint: 'Orientation vers les spécialistes'
    },
    rendezVous: {
      label: 'Rendez-vous',
      hint: 'Planification et statuts'
    }
  },

  /** Page dossier patient (consultations par filière + passages accueil). */
  DOSSIER: {
    PAGE_TITLE: 'Dossier complet',
    PAGE_SUBTITLE_MEDICAL:
      'Dossier médical : consultations médecine générale, ordonnances, suivi infirmier, passages accueil et rendez-vous médicaux.',
    PAGE_SUBTITLE_DENTAL:
      'Dossier dentaire : consultations DENTAL, passages accueil orientés dentiste et rendez-vous dentaires.',

    SEARCH_CARD_TITLE: 'Rechercher un adhérent',
    SEARCH_LABEL: 'Adhérent',
    SEARCH_PLACEHOLDER: 'Matricule, nom ou prénom…',
    SEARCH_HINT:
      'Suggestions après 2 caractères · matricule exact + Entrée ou bouton Ouvrir.',
    SEARCH_SUBMIT: 'Ouvrir',

    MULTIPLE_MAT_TITLE: 'Plusieurs fiches correspondent — choisissez :',

    EMPTY_STATE:
      'Recherchez un adhérent (matricule ou nom) pour ouvrir le dossier médical consolidé.',

    IDENTITY_TITLE: 'Identité & société',
    CLEAR_MEMBER: 'Changer d’adhérent',
    LABEL_SOCIETY: 'Société :',
    LABEL_SEXE: 'Sexe :',
    LABEL_NAIS: 'Naissance :',
    LABEL_FONCTION: 'Fonction :',
    SEXE_M: 'Masculin',
    SEXE_F: 'Féminin',

    VITALS_HINT:
      'Les constantes (poids, tension, température, etc.) suivent celles renseignées sur chaque consultation de la filière affichée ci-dessous.',

    CONSULT_SECTION: 'Consultations (médecine générale)',
    CONSULT_SECTION_DENTAL: 'Consultations dentaires',
    CONSULT_EMPTY: 'Aucune consultation médicale pour cet adhérent.',
    CONSULT_EMPTY_DENTAL: 'Aucune consultation dentaire pour cet adhérent.',
    VISITS_SECTION: 'Passages à l’accueil',
    VISITS_EMPTY: 'Aucun passage enregistré pour ce matricule.',

    TOAST_SEARCH_REQUIRED: 'Saisissez un matricule ou un nom.',
    TOAST_NO_MEMBER: 'Aucun adhérent actif pour ce critère.',
    TOAST_LOADED: 'Adhérent chargé.',
    TOAST_ERROR: 'Requête impossible.',
    ERROR_LOAD: 'Chargement du dossier impossible.',

    STATUS_DONE: 'Terminée',
    STATUS_PENDING: 'En attente',
    STATUS_CANCEL: 'Annulée'
  },

  PLACEHOLDER_BACK: 'Retour au tableau de bord',

  MODULE_PLACEHOLDER: {
    dossier: {
      title: 'Dossier complet',
      description:
        'Ce module est disponible depuis « Dossier complet » dans le menu. Synthèse adhérent : consultations par filière, constantes renseignées et historique réception.',
      icon: 'history'
    },
    diagnostic: {
      title: 'Diagnostic',
      description:
        'Saisie assistée codifiée (référentiels) avec texte libre pour précisions · module à planifier.',
      icon: 'stethoscope'
    },
    examens: {
      title: 'Demandes d’examens',
      description:
        'Analyses biologiques, imagerie et examens complémentaires avec suivi du circuit vers les partenaires · module à planifier.',
      icon: 'chartBar'
    },
    certificats: {
      title: 'Certificats d’aptitude',
      description:
        'Certificats d’aptitude ou d’inaptitude avec circuit de supervision et jalons hiérarchiques · module à planifier.',
      icon: 'shield'
    },
    joursRepos: {
      title: 'Jours de repos',
      description:
        'Attribution avec processus de validation intégré (circuits internes ou hiérarchiques) · module à planifier.',
      icon: 'pause'
    },
    lettresReference: {
      title: 'Lettres de référence',
      description:
        'Rédaction structurée de courriers vers les spécialistes (contexte dossier exportable) · module à planifier.',
      icon: 'arrowRight'
    },
    rendezVous: {
      title: 'Rendez-vous',
      description:
        'Planification et suivi des statuts (confirmé, présenté, reporté, annulé) · module à planifier.',
      icon: 'calendar'
    }
  },

  /** Cartes hub — médecins prescripteurs (ordonnances visibles). */
  HUB_CARD_DEFS_PHYSICIAN: [
    {
      kind: 'route',
      routeKey: 'DOSSIER',
      title: 'Dossier complet',
      subtitle: 'Historique consultations (filière) et passages accueil',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'CONSULTATIONS',
      title: 'Consultations',
      subtitle: 'File du site sélectionné',
      badge: 'ready'
    },
    {
      kind: 'route',
      routeKey: 'DIAGNOSTIC',
      title: 'Diagnostic',
      subtitle: 'Codifié ou texte libre selon vos besoins',
      badge: 'soon'
    },
    {
      kind: 'route',
      routeKey: 'PRESCRIPTIONS',
      title: 'Ordonnances',
      subtitle: 'Ordonnances numériques liées à la pharmacie',
      badge: 'ready',
      requiresPrescriber: true
    },
    {
      kind: 'route',
      routeKey: 'EXAMENS',
      title: 'Examens',
      subtitle: 'Analyses et complémentaires',
      badge: 'soon'
    },
    {
      kind: 'route',
      routeKey: 'CERTIFICATS',
      title: 'Certificats',
      subtitle: 'Aptitude ou inaptitude · supervision',
      badge: 'soon'
    },
    {
      kind: 'route',
      routeKey: 'MALADIES',
      title: 'Maladies',
      subtitle: 'Gestion du référentiel médical',
      badge: 'ready',
      requiresHeadDoctor: true
    },
    {
      kind: 'route',
      routeKey: 'ANALYSES',
      title: 'Analyses médicales',
      subtitle: 'Catalogue des examens biologiques',
      badge: 'ready',
      requiresHeadDoctor: true
    },
    {
      kind: 'route',
      routeKey: 'RADIOGRAPHIES',
      title: 'Radiographies',
      subtitle: 'Catalogue des actes d\'imagerie',
      badge: 'ready',
      requiresHeadDoctor: true
    },
    {
      kind: 'route',
      routeKey: 'JOURS_REPOS',
      title: 'Jours de repos',
      subtitle: 'Certificats d\'arrêt depuis la consultation',
      badge: 'ready',
      requiresHeadDoctor: true
    },
    {
      kind: 'route',
      routeKey: 'LETTRES_REFERENCE',
      title: 'Lettres de référence',
      subtitle: 'Vers les spécialistes',
      badge: 'soon',
      requiresHeadDoctor: true
    },
    {
      kind: 'route',
      routeKey: 'RENDEZ_VOUS',
      title: 'Rendez-vous',
      subtitle: 'Planification et statuts',
      badge: 'soon',
      requiresHeadDoctor: true
    },
    {
      kind: 'newConsult',
      title: 'Nouvelle consultation',
      subtitle: 'Création rapide (même formulaire que la barre latérale)',
      badge: 'ready'
    }
  ],

  DASHBOARD: {
    PAGE_TITLE_PHYSICIAN: 'Tableau de bord',
    PAGE_TITLE_DENTIST: 'Tableau de bord',
    PAGE_SUBTITLE_PHYSICIAN:
      'Pilotage clinique du site sélectionné : consultations, dossier adhérent et modules métiers.',
    PAGE_SUBTITLE_DENTIST:
      'Pilotage clinicodentaire du site sélectionné. Les indicateurs concernent la filière DENTAL.',

    HUB_SECTION_TITLE: 'Parcours cliniques et administratifs',
    HUB_SECTION_SUBTITLE:
      'Entrez dans chaque module · les vignettes « à venir » ouvrent le cadrage détaillé SMIE.',

    STATS_SECTION_TITLE: 'Indicateurs du site',

    STATS_CONSULT_TITLE: 'Consultations (site courant)',
    STAT_TOTAL: 'Total',
    STAT_PENDING: 'En attente',
    STAT_COMPLETED: 'Terminées',
    STAT_CANCELLED: 'Annulées',

    STATS_RX_TITLE: 'Ordonnances médicales',
    STAT_RX_TOTAL: 'Total',
    STAT_RX_ACTIVE: 'Actives',
    STAT_RX_FULFILLED: 'Remplies',

    BADGE_READY: 'Actif',
    BADGE_SOON: 'À venir',

    CARD_CONSULT_LIST_TITLE: 'Consultations détaillées',
    CARD_CONSULT_LIST_DESC: 'Liste filtrable du site',
    CARD_NEW_CONSULT_TITLE: 'Nouvelle consultation',
    CARD_NEW_CONSULT_DESC: 'Ouverture du formulaire métier',
    CARD_RX_TITLE: 'Ordonnances',
    CARD_RX_DESC: 'Historique prescriptions pharmacie-liées'
  },

  /** Indicateur AT sur une consultation (Oui / Non). */
  WORK_ACCIDENT: {
    LABEL: 'Accident du travail',
    YES: 'Oui',
    NO: 'Non',
    HINT: 'À renseigner si la prise en charge est liée à un AT déclaré.',
    LOCATION_LABEL: 'Lieu de l\'accident',
    LOCATION_WORK: 'Sur le travail',
    LOCATION_COMMUTE: 'Sur le trajet',
    SEVERITY_LABEL: 'Gravité',
    SEVERITY_ATG: 'ATG',
    SEVERITY_ATB: 'ATB',
    VALIDATION_LOCATION: 'Indiquez le lieu de l\'accident (sur le travail ou sur le trajet).',
    VALIDATION_SEVERITY: 'Indiquez la gravité de l\'AT (ATG ou ATB).',
    MODAL_TITLE: 'Accident du travail',
    MODAL_INTRO: 'Confirmez la prise en charge AT et précisez le lieu et la gravité.',
    MODAL_CONFIRM: 'Confirmer l\'AT',
    MODAL_CANCEL: 'Annuler',
    SUMMARY_EDIT: 'Modifier',
    BADGE_AT: 'AT',
    LIST_BADGE_AT: 'Accident du travail'
  },

  PROFESSIONAL_DISEASE: {
    LABEL: 'Maladie professionnelle',
    YES: 'Oui',
    NO: 'Non',
    HINT: 'À renseigner si la prise en charge est liée à une maladie professionnelle déclarée.',
    BADGE_MP: 'MP',
    LIST_BADGE_MP: 'Maladie professionnelle'
  }
};
